import PropTypes from "prop-types";
import { GraduationCap } from "lucide-react";

const classOfDegreeMap = {
  second_class_upper: "Second Class Upper",
  second_class_lower: "Second Class Lower",
  first_class: "First Class",
};

const ReportField = ({ label, value }) => (
  <div className="flex flex-col border-b border-slate-100 pb-2 last:border-0 last:pb-0">
    <span className="text-[10px] text-slate-400 uppercase font-bold tracking-wider mb-1">
      {label}
    </span>
    <span className="text-sm font-medium text-slate-600">{value || "N/A"}</span>
  </div>
);

function AcademicDetails({ details }) {
  const academicDetails = [
    { label: "Name of School", value: details?.institution?.name },
    { label: "Course of Study", value: details?.course?.name },
    // { label: "Year of Graduation", value: details?.year_of_graduation },
    { label: "Matric Number", value: details?.matric_number },
    // {
    //   label: "Grade",
    //   value:
    //     classOfDegreeMap[details?.graduating_class] ||
    //     details?.graduating_class,
    // },
  ];

  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden w-full">
      <div className="bg-slate-50 px-6 py-3 border-b border-slate-100 flex items-center gap-2">
        <GraduationCap size={16} className="text-slate-500" />
        <h2 className="text-xs font-bold text-slate-700 uppercase tracking-wider">
          Academic Details
        </h2>
      </div>
      <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
        {academicDetails.map((detail, index) => (
          <ReportField key={index} label={detail.label} value={detail.value} />
        ))}
      </div>
    </div>
  );
}

AcademicDetails.propTypes = {
  details: PropTypes.shape({
    institution: PropTypes.shape({
      name: PropTypes.string,
    }),
    course: PropTypes.shape({
      name: PropTypes.string,
    }),
    year_of_graduation: PropTypes.string,
    matric_number: PropTypes.string,
    graduating_class: PropTypes.string,
  }),
};

export default AcademicDetails;
